export const COLORS = {
  river: 0x55bfe6,
  riverDeep: 0x267ea6,
  grass: 0x70c66b,
  grassLight: 0x91db78,
  soil: 0xb78b5b,
  warning: 0xffc83d,
  danger: 0xff5f57,
  success: 0x5bd675,
  coral: 0xff6b4a,
  uiDark: 0x263548,
  uiLight: 0xfff7e8,
  sky: 0x9ddff3,
  stone: 0xb6aa9a,
  white: 0xffffff,
  ink: 0x172536,
} as const;
